import { useAuth } from '@wix/cli-auth';
import { useMemo } from 'react';
import { usePanoramaMethodLogger } from '@wix/cli-panorama';
import { VeloTypesSyncClient } from './velo-types-sync-client.js';

export function useVeloTypesSyncClient(projectFolder: string) {
  const { getAccessToken } = useAuth();

  const client = useMemo(
    () => new VeloTypesSyncClient(projectFolder, getAccessToken),
    [projectFolder, getAccessToken]
  );

  return usePanoramaMethodLogger(client);
}
